import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cson",
  "use": "icon-cson-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-cson\"><path fill=\"#333333\" d=\"M835.584 35.84v122.88H35.84v-122.88m152.576 276.48h799.744v122.88H188.416v-122.88zM35.84 586.752h799.744v123.904H35.84V586.752z m152.576 277.504h799.744v123.904H188.416V864.256z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol